import useProtoMethod from "./useProtoMethod";
import {
  StartTaskAgentRequest,
  StartTaskAgentResponse,
  AnswerAgentQuestionRequest,
  AnswerAgentQuestionResponse,
  AgentMessageResponse,
  AgentMessageRequest,
} from "protogen/agents_service_pb";
import { getApiDomain } from "../constants";

const useStartTaskAgent = (callback?: (r: StartTaskAgentResponse) => void) => {
  return useProtoMethod<StartTaskAgentRequest, StartTaskAgentResponse>(
    "StartTaskAgent",
    StartTaskAgentResponse,
    { baseUrl: getApiDomain(), callback },
  );
};

const useAnswerAgentQuestion = (
  callback?: (r: AnswerAgentQuestionResponse) => void,
) => {
  return useProtoMethod<
    AnswerAgentQuestionRequest,
    AnswerAgentQuestionResponse
  >("AnswerAgentQuestion", AnswerAgentQuestionResponse, {
    baseUrl: getApiDomain(),
    callback,
  });
};

const useAgentMessage = (callback?: (r: AgentMessageResponse) => void) => {
  return useProtoMethod<AgentMessageRequest, AgentMessageResponse>(
    "AgentMessage",
    AgentMessageResponse,
    { baseUrl: getApiDomain(), callback },
  );
};

export { useStartTaskAgent, useAnswerAgentQuestion, useAgentMessage };
